module.exports = __webpack_public_path__ + "img/e_commerce_request_error_icon.13170213.png";